"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAddressParams = void 0;
const errors_1 = require("../../errors");
const invalidDataReason_1 = require("../../errors/invalidDataReason");
const internal_1 = require("../../types/internal");
const utils_1 = require("../../utils");
const assert_1 = require("../../utils/assert");
const serialize_1 = require("../../utils/serialize");
const getVersion_1 = require("../getVersion");
function serializeSpendingDataSource(dataSource) {
    switch (dataSource.type) {
        case "spending_path":
            return serialize_1.path_to_buf(dataSource.path);
        case "spending_script_hash":
            return serialize_1.hex_to_buf(dataSource.scriptHashHex);
        case "no_spending":
            return Buffer.alloc(0);
    }
}
function serializeStakingDataSource(dataSource) {
    const stakingChoicesEncoding = {
        ["no_staking"]: 0x11,
        ["staking_key_path"]: 0x22,
        ["staking_key_hash"]: 0x33,
        ["blockchain_pointer"]: 0x44,
        ["staking_script_hash"]: 0x55,
    };
    switch (dataSource.type) {
        case "no_staking": {
            return Buffer.concat([
                serialize_1.uint8_to_buf(stakingChoicesEncoding[dataSource.type]),
            ]);
        }
        case "staking_key_hash": {
            return Buffer.concat([
                serialize_1.uint8_to_buf(stakingChoicesEncoding[dataSource.type]),
                serialize_1.hex_to_buf(dataSource.keyHashHex),
            ]);
        }
        case "staking_script_hash": {
            return Buffer.concat([
                serialize_1.uint8_to_buf(stakingChoicesEncoding[dataSource.type]),
                serialize_1.hex_to_buf(dataSource.scriptHashHex),
            ]);
        }
        case "staking_key_path": {
            return Buffer.concat([
                serialize_1.uint8_to_buf(stakingChoicesEncoding[dataSource.type]),
                serialize_1.path_to_buf(dataSource.path),
            ]);
        }
        case "blockchain_pointer": {
            return Buffer.concat([
                serialize_1.uint8_to_buf(stakingChoicesEncoding[dataSource.type]),
                serialize_1.uint32_to_buf(dataSource.pointer.blockIndex),
                serialize_1.uint32_to_buf(dataSource.pointer.txIndex),
                serialize_1.uint32_to_buf(dataSource.pointer.certificateIndex),
            ]);
        }
    }
}
function serializeAddressParams(params, version) {
    let spending = params.spendingDataSource;
    let staking = params.stakingDataSource;
    if (!getVersion_1.getCompatibility(version).supportsMultisigTransaction) {
        if (params.type === internal_1.AddressType.REWARD_KEY) {
            assert_1.assert(staking.type === "staking_key_path", invalidDataReason_1.InvalidDataReason.ADDRESS_INVALID_STAKING_INFO);
            spending = {
                type: "spending_path",
                path: staking.path,
            };
            staking = {
                type: "no_staking",
            };
        }
        else if (params.type === internal_1.AddressType.REWARD_SCRIPT) {
            throw new errors_1.DeviceVersionUnsupported(`Scripthash based address derivation not supported by Ledger app version ${utils_1.getVersionString(version)}.`);
        }
    }
    return Buffer.concat([
        serialize_1.uint8_to_buf(params.type),
        params.type === internal_1.AddressType.BYRON
            ? serialize_1.uint32_to_buf(params.protocolMagic)
            : serialize_1.uint8_to_buf(params.networkId),
        serializeSpendingDataSource(spending),
        serializeStakingDataSource(staking),
    ]);
}
exports.serializeAddressParams = serializeAddressParams;
//# sourceMappingURL=data:application/json;base64,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